module.exports = __webpack_public_path__ + "./LuffyPhoto_b1a4552102f0f7dbbec36b35b0d677fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/LuffyPhoto.png
// module id = 497
// module chunks = 0